export const regexp = {
  creditCode: /^[0-9A-Z]{18}$/,
  email: /^[.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  phone: /^1\d{10}$/,
  linkBankAccount: /^\d{12}$/,
  PcreditCode: /^[0-9A-Za-z]{18}$/,
  bankAccount: /^[0-9]{1,}$/,
  nmb: /^[0-9]{1,}([.]{1}[0-9]{1,})?$/,
  price: /^[0-9]{1,}([.]{1}[0-9]{1,4})?$/,
  number: /^\d{1,}$/,
  startingQuantity: /^[0-9]{1,}([.]{1}[0-9]{1,2})?$/,
  Pemail: /.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9]+)+$/,
  ID: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  fixedTel: /0\d{2,3}-\d{7,8}/,
  passWord: /^((?=.*\d)(?=.*[A-Za-z])|(?=.*\d)(?=.*[!@#$%^&*()_+-/])|(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+-/]))[\da-zA-Z_+-/!@#$%^&*()]{6,16}$/,
  passWordRow: (complexity = 2, len = 6) => {
    switch (complexity) {
      case 0:
        return `^((?=.*[0-9])(?=.*[a-z]))[0-9a-z]{${len},64}$`
      case 1:
        return `^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]{${len},64}$`
      case 3:
        return `^((?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+-/])|(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+-/]))[0-9a-zA-Z_+-/!@#$%^&*()]{${len},64}$`
      case 4:
        return `^((?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+-/]))[0-9a-zA-Z_+-/!@#$%^&*()]{${len},64}$`
      case 2:
        return `^((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[!@#$%^&*()_+-/])|(?=.*[a-z])(?=.*[A-Z])|(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+-/])|(?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+-/]))[0-9a-zA-Z_+-/!@#$%^&*()]{${len},64}`
    }
  }
}
